export interface  ContractModel //DsContract
{
    AuditAvl_BARReportExport:boolean ,
    AuditStd_LOSActive:boolean ,
    ContractID:number ,
    CustomerID:number ,
    RateAvailability:boolean ,
    StandardRateAudit:boolean ,
    ReverseAudit:boolean ,
}